/* eslint-disable react/prop-types */
import { FC } from "react";

import styles from "./searchResultList.module.scss";
import TopRightArrowIcon from "@Icons/TopRightArrowIcon";
import wrapperHOC from "@Utils/wrapperHOC";
import Locality from "@Icons/SearchDropdownIcons/Locality";
import City from "@Icons/SearchDropdownIcons/City";
import Property from "@Icons/SearchDropdownIcons/Property";
import University from "@Icons/SearchDropdownIcons/University";
import Document from "@Icons/Document";
import config from "@Config/index";

const ListItem: FC<any> = ({ data, index, getItemProps, selectedIndex, dataTestId }) => {
  const primaryName = data.name;
  const secondaryName = data.location?.name || data.address;
  const resultType = data?.type;
  const rawAbbreviation = data?.abbreviation;
  const abbreviation = Array.isArray(rawAbbreviation)
    ? rawAbbreviation.filter(Boolean).join(", ")
    : rawAbbreviation || "";
  const name_zh = data?.name_zh;
  const address_zh = data?.address_zh;

  const itemProps = getItemProps({ data });

  const handleListItemClick = (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
    itemProps?.onClick(event);
  };
  let itemType = "";
  let IconComponent = () => <TopRightArrowIcon />;

  switch (resultType) {
    case "blog":
      itemType = "Blog";
      IconComponent = () => <Document />;
      break;
    case "establishment":
      itemType = "University";
      IconComponent = () => <University />;
      break;
    case "inventory":
      itemType = "Property";
      IconComponent = () => <Property />;
      break;
    case "locality":
      itemType = "City";
      IconComponent = () => <City />;
      break;
    case "sublocality":
      itemType = "Locality";
      IconComponent = () => <Locality />;
      break;
    default:
      itemType = "City";
      IconComponent = () => <City />;
  }
  return (
    <li
      id={`searchListItem${index}`}
      {...itemProps}
      className={styles.listItemLi}
      role="none"
      onClick={handleListItemClick}
    >
      <div
        className={`${styles.listItem} ${index === selectedIndex ? styles.selectedListItem : ""}`}
        data-testid={dataTestId}
      >
        <div className={styles.iconContainer}>
          <div className={styles.icon}>
            <IconComponent />
          </div>
        </div>
        <div className={styles.itemContainer}>
          <div className={styles.textContainer}>
            {config.IS_CHINA_APP && name_zh && resultType !== "inventory" && (
              <div className={styles.primaryName}>
                {abbreviation ? `(${abbreviation}) ` : ""}
                {name_zh}
                {address_zh && resultType !== "establishment" ? ` ${address_zh}` : ""}
              </div>
            )}
            <div
              className={
                config.IS_CHINA_APP && name_zh && resultType !== "inventory"
                  ? styles.secondaryName
                  : styles.primaryName
              }
            >
              {config.IS_CHINA_APP && abbreviation ? `(${abbreviation}) ` : ""}
              {primaryName}
              {!config.IS_CHINA_APP && abbreviation ? ` (${abbreviation})` : ""}
              {config.IS_CHINA_APP && resultType !== "inventory" && secondaryName
                ? `, ${secondaryName}`
                : ""}
            </div>
            {!config.IS_CHINA_APP && secondaryName && (
              <div className={styles.secondaryName}>{secondaryName}</div>
            )}
            {config.IS_CHINA_APP && resultType === "inventory" && secondaryName && (
              <div className={styles.secondaryName}>{secondaryName}</div>
            )}
          </div>
          <div className={styles.itemType}>{itemType}</div>
        </div>
      </div>
    </li>
  );
};

export default wrapperHOC(ListItem, {
  componentName: "ListItem-SearchResultList-SearchModalMobile-Global",
  showForChina: true,
});
